import PropTypes from 'prop-types';
import React, { Component } from 'react';
import i18next from "../../i18n";
import { maxRequestAttachmentSize } from '../../constants';
import { DateTimeField } from '../form/DateTimeField';
import { padWithZeroes } from '../form/Form';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import * as HelperFunctions from '../helpers/HelperFunctions';
import * as CheckFunctions from '../helpers/CheckFunctions';
export class AttachmentForm extends Component {
    static propTypes = {
        typesOfDocumens: PropTypes.array.isRequired,
        documentType: PropTypes.string,
        handleAddDocument: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            submitted: false
        }
        let keys = Object.keys(this.props);
        for (let i = 0; i < keys.length; ++i) this.state[keys[i]] = this.props[keys[i]];
        this.state.documentDate = this.props.documentDate ? this.getDate(this.props.documentDate) : undefined;
        this.state.documentType = this.state.documentType ?? (this.props.typesOfDocumens[0]?.value ?? "");
        this.changeInputValue = this.changeInputValue.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleAddDocument = this.handleAddDocument.bind(this);
    }
    componentDidUpdate() {
        if (this.props.typesOfDocumens !== this.state.typesOfDocumens) {
            this.setState({ typesOfDocumens: this.props.typesOfDocumens });
        }
    }
    onCancel() {
        const { onCloseHandler } = this.props;
        if (!this.state.sending && onCloseHandler)
            onCloseHandler();
    }
    render() {
        const { documentType, title, documentNumber, documentDate, comment, submitted, id, typesOfDocumens } = this.state;
        return (
            <>
                <div className="modal-body">
                    <form name="form" className="popupSimple">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="required">{i18next.t("documentType")}</label>
                                    <select name="documentType" className="form-control" value={documentType} onChange={this.changeInputValue}>
                                        {typesOfDocumens && typesOfDocumens.map(item =>
                                            <option key={item.value} value={item.value}>{item.title}</option>
                                        )}
                                    </select>
                                    {submitted && !documentType ? <div className="help-block">{i18next.t("requiredField")}</div> : ""}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label>{i18next.t("documentNumber")}</label>
                                    <input name="documentNumber" className="form-control" value={documentNumber} onChange={this.changeInputValue} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label className="required">{i18next.t("documentDate")}</label>
                                    <DateTimeField
                                        name="documentDate"
                                        format="date"
                                        value={documentDate}
                                        onChange={this.changeInputValue}
                                    />
                                    {submitted && !documentDate ? <div className="help-block">{i18next.t("requiredField")}</div> : ""}
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label>{i18next.t("comment")}</label>
                                    <textarea name="comment" rows="4" className="form-control" onChange={this.changeInputValue} value={comment}></textarea>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    {title ?
                                        <label className="upload-file-label">{title}<span className="close-btn" onClick={this.removeFile}></span></label>
                                        :
                                        <>
                                            <label className={"upload-file-label upload-file-btn"} onClick={() => document.getElementById("file-iput-controll").click()}>{i18next.t("addFile")}</label>
                                            <input className="file-select" name="file" id="file-iput-controll" onChange={this.changeInputValue} type="file" style={{ display: "none" }} />
                                        </>
                                    }
                                    {submitted && !title ? <div className="help-block">{i18next.t("requiredField")}</div> : ""}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <div className="form-group form-group__last">
                        <button type="button" className="btn btn-primary" onClick={this.handleAddDocument}>{id ? i18next.t("save") : i18next.t("add")}</button>
                        <button type="button" className="btn btn-secondary" onClick={this.onCancel}>{i18next.t("cancel")}</button>
                        <div className="required-label">
                            <label className="required" />{i18next.t("requiredFields")}
                        </div>
                    </div>
                </div>
            </>
        );
    }
    changeInputValue(e) {
        const { files } = e.target;
        if (files) {
            let errorMessage = CheckFunctions.getFileAttachmentErrorMessage(e.target.files[0], null, maxRequestAttachmentSize);
            if (errorMessage) {
                showModalDialog("modalSubDialog", i18next.t("message"), "", <div className="info-message">{errorMessage}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: () => hideModalDialog("modalSubDialog"), class: "btn-primary" }]);
                e.target.value = null;
            }
            else {
                this.setState({
                    badExtension: false,
                    file: e.target.files[0],
                    title: e.target.files[0].name
                });
            }
        }
        else HelperFunctions.changeInputValue.bind(this)(e);
    }
    removeFile(e) {
        this.setState({ file: null, title: "" });
    }
    handleAddDocument(e) {
        e.preventDefault();
        this.setState({
            submitted: true
        });
        const { title, documentType, id, documentDate } = this.state;
        if (this.props.handleAddDocument && documentType && title && documentDate) {
            this.props.handleAddDocument(Object.assign({ id: id ? id : (new Date().getTime()).toString() }, this.state));
        }
    }
    getDate(value) {
        const date = new Date(value);
        return `${date.getFullYear()}-${padWithZeroes(date.getMonth() + 1, 2)}-${padWithZeroes(date.getDate(), 2)}`;
    }
}
